import Model from "./Model";
import Taxonomy from "@/interfaces/Taxonomy";

export default class ProductCategory extends Model implements Taxonomy {
  static type = "productCategories";

  name!: string;
  classes?: Array<Taxonomy>;

  get type(): string {
    return ProductCategory.type;
  }
}
